// Auto-generated queries for AiCredits domain — DO NOT EDIT.

import type { ComputedQueryDef, QueryDef } from '@voicedojo/api';
import type { CreditEstimate, CreditHistoryPage, CreditReceipt } from '../responses.g.js';
import type { AiCreditAccount } from './ReadModels.g.js';
import type { AiCreditSource, CreditAction, FrameworkLens } from '../enums.g.js';
import type { SeriesId } from '../ids.g.js';

export interface CreditEstimationQuery {
  action: CreditAction;
  durationSeconds?: number | null;
  lenses?: FrameworkLens[];
  pronunciation?: boolean;
  seriesId?: SeriesId | null;
  plannedDurationSeconds?: number | null;
}

export interface CreditHistoryQuery {
  page?: number;
}

export interface CreditReceiptQuery {
  source: AiCreditSource;
  subject?: string | null;
  since?: string | null;
}

export interface FindAiCreditAccountByUserQuery {
}

/** ComputedQueryDef descriptor for POST /api/query ($type: 'CreditEstimationQuery'). */
export const creditEstimation: ComputedQueryDef<CreditEstimationQuery, CreditEstimate> = { $type: 'CreditEstimationQuery' };

/** ComputedQueryDef descriptor for POST /api/query ($type: 'CreditHistoryQuery'). */
export const creditHistory: ComputedQueryDef<CreditHistoryQuery, CreditHistoryPage> = { $type: 'CreditHistoryQuery' };

/** ComputedQueryDef descriptor for POST /api/query ($type: 'CreditReceiptQuery'). */
export const creditReceipt: ComputedQueryDef<CreditReceiptQuery, CreditReceipt> = { $type: 'CreditReceiptQuery' };

/** QueryDef descriptor for POST /api/query ($type: 'FindAiCreditAccountByUserQuery'). */
export const findAiCreditAccountByUser: QueryDef<FindAiCreditAccountByUserQuery, AiCreditAccount> = {
  $type: 'FindAiCreditAccountByUserQuery',
  watch: 'AiCreditAccount',
};

